import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectUserProfile } from '../../modules/user';

interface UserTypePrivateRouteProps {
  allowedUserTypes: string[];
}

const UserTypePrivateRoute: React.FC<UserTypePrivateRouteProps> = ({ allowedUserTypes }) => {
  const { data, loading } = useSelector(selectUserProfile);
  const userType = data?.user_type;

  if (loading) {
    return <div></div>;
  }

  if (!userType || !allowedUserTypes.includes(userType)) {
    return <Navigate to="/" />;
  }

  return <Outlet />;
};

export default UserTypePrivateRoute;
